import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Text from '@/components-latest/primitives/Text'
import { IBillingRevenue } from '@/ducks/billing/billing.types'
import { selectCurrencyCode } from '@/ducks/store/selectors/store.selectors'
import { formatPrice } from '@/utils/currency.utils'

import Styles from './BillingRevenue.module.scss'

type Props = {
  revenue?: IBillingRevenue
  revenueType?: string
}

const BillingRevenue = ({ revenue, revenueType }: Props) => {
  const { t } = useTranslation()
  const currency = useSelector(selectCurrencyCode) || ''

  return (
    <div data-testid="billing-revenue" className={clsx(Styles.paymentSummary)}>
      <div className={Styles.summaryRow}>
        <Text variant="nextBody">{t('billing.details.revenue-earning')}</Text>
        <div className={Styles.dots} />
        <Text variant="nextBody" weight="semiBold">
          {formatPrice(revenue?.total_restaurant_earnings || 0, currency, {
            signDisplay: 'always'
          })}
        </Text>
      </div>

      <div className={Styles.summaryRow}>
        <Text variant="nextBody">{t('billing.details.revenue-comission')}</Text>
        <div className={Styles.dots} />
        <Text variant="nextBody" weight="semiBold">
          {formatPrice(revenue?.total_admin_earnings || 0, currency, {
            signDisplay: 'auto'
          })}
        </Text>
      </div>

      {revenueType === 'FRANCE' ? (
        <>
          <div className={Styles.summaryRow}>
            <Text variant="nextBody">{t('billing.details.revenue-vat')}</Text>
            <div className={Styles.dots} />
            <Text variant="nextBody" weight="semiBold">
              {formatPrice(revenue?.sum_tax_restaurant || 0, currency, {
                signDisplay: 'auto'
              })}
            </Text>
          </div>

          <div className={Styles.summaryRow}>
            <Text variant="nextBody">
              {t('billing.details.revenue-due-to-receive')}
            </Text>
            <div className={Styles.dots} />
            <Text variant="nextBody" weight="semiBold">
              {formatPrice(revenue?.final_admin_earnings || 0, currency, {
                signDisplay: 'auto'
              })}
            </Text>
          </div>
        </>
      ) : null}
    </div>
  )
}

export default BillingRevenue
